import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/PickFavorites';

export const PICK_FAVORITES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const PICK_FAVORITES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const PICK_FAVORITES_QUEUE_UPDATE = `${rootActionPath}/QUEUE_UPDATE`;
export const PICK_FAVORITES_VIEW = `${rootActionPath}/VIEW`;
